import { Typography } from "@mui/material";
import React from "react";

const ErrorMessage = ({ title, children }) => {
  return (
    <div className="p-4">
      <Typography variant="h4" sx={{ color: "red" }}>
        {title || "¡Error!"}
      </Typography>
      {children}
    </div>
  );
};

export default ErrorMessage;
